import { render, staticRenderFns } from "./HandTypes.vue?vue&type=template&id=243eb1f0&scoped=true&"
import script from "./HandTypes.vue?vue&type=script&lang=js&"
export * from "./HandTypes.vue?vue&type=script&lang=js&"
import style0 from "./HandTypes.vue?vue&type=style&index=0&id=243eb1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243eb1f0",
  null
  
)

export default component.exports